import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qeb3h4mtm: FaireProductEntity = {
  token: "p_6qeb3h4mtm",
  type: "product",
  name: "Pacific Stripe Organic Girl Romper",
  brandToken: "b_np5ktd5ja2",
  brandName: "Burt's Bees Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/6e0facfbdf6ce5f55777500bf9a943e968b78478ae9f8997a4ea5cf79624569c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4972d00cdc6bef3e53a09219e0e998c321864ba3b8594daa918d89708e1706a.png",
    "https://cdn.faire.com/fastly/0d89941230a04e8cdd2adb55c6dfcb7164f4148d9bf5335964dbae2ed9dc87f6.png",
  ],
  priceDollars: 11.5,
  description:
    "Burt's Bees Baby presents the Pacific Stripe Organic Girl Romper, a delightful addition to your little one's wardrobe. Crafted with the gentlest organic cotton, this romper is both comfortable and safe for your baby's delicate skin. The Pacific Stripe design adds a touch of playfulness, making it an ideal choice for daily wear or special occasions. Sustainability is at the heart of our brand, and this romper is no exception, made with eco-friendly materials and packaged responsibly. Trust in Burt's Bees Baby for quality and care for your little one.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:28.009Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
